<template>
  <body data-v-7ba5bd90="" class="akl">
  <div id="skipToContent"><a href="#contents">콘텐츠 바로가기 </a></div>
  <div class="renew-compliance">
    <div class="general-header"></div>

    <div class="container amway-theme" id="contents">
        <h1 class="title-h2">클럽타올라 회원약관</h1>
        <div class="compliance-area privacy">

            <div class="termsWrapper">
                <div class="col-search-tab link-to">
                    <ul>
                        <li class="active"><a @click="scrollToElement('titNo01')" data-toggle="tab">앱 이용 동의서</a></li>
                        <li><a @click="scrollToElement('titNo02')" data-toggle="tab">개인 정보 이용 동의</a></li>
                        <li><a @click="scrollToElement('titNo03')" data-toggle="tab">민감정보 활용 동의</a></li>
                        <li><a @click="scrollToElement('titNo04')" data-toggle="tab">개인정보 처리방침</a></li>
                    </ul>
                </div>
                <ul>
                    <!-- S : 앱 이용 동의서 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo01" ref="titNo01" >한국암웨이 클럽 타올라 앱 이용 동의서</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제1조 (목적)</p>
                                    <p class="titHtext pdbNone">본 이용 동의서는 한국암웨이 주식회사(이하 “회사”라 합니다)가 제공하는 클럽 타올라 앱과 관련된 “회사”와 “이용자” 간의 권리, 의무 및 책임사항과 절차 등을 규정함을 목적으로 합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제2조 (정의)</p>
                                    <p class="titHtext">본 이용 동의서에서 사용하는 용어의 의미는 다음과 같습니다.</p>
                                    <ol>
                                        <li>① “<b>이용자</b>”란 25센트 라이드 앱 회원을 말하는 것으로, 클럽 타올라 앱은 25센트 라이드 앱의 부가 서비스로써 25센트 라이드 앱 회원은 클럽타올라 앱을 통해 "서비스"를 제공받을 수 있습니다.</li>
                                        <li>② “<b>서비스</b>”란 클럽 타올라 앱을 통해 “회사”가 "이용자"에게 제공하는 모든 프로그램 일체를 말합니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제3조 (이용 동의서의 명시 및 효력 변경)</p>
                                    <ol>
                                        <li>① “회사”는 본 이용 동의서를 “이용자”가 쉽게 열람할 수 있도록 본 이용 동의서를  클럽 타올라 앱의 설정 메뉴에 게시하거나 팝업 화면 등으로 제공합니다.</li>
                                        <li>② “회사”는 『전자상거래 등에서의 소비자보호에 관한 법률』, 『약관의 규제에 관한 법률』, 『정보통신망 이용촉진 및 정보보호에 관한 법률』 등 관련 법을 위반하지 않는 범위 내에서 본 이용 동의서를 개정할 수 있습니다.</li>
                                        <li>③ “회사”가 본 이용 동의서를 개정할 경우에는 적용일자 및 개정사유를 명시하여 본 조 제1항의 방식에 따라 그 개정 이용 동의서의 효력이 발생하는 날의 7일 전부터 그 개정 이용 동의서의 효력이 발생하는 날의 전일까지 공지합니다. 다만, “이용자”에게 불리한 약관 개정의 경우에는 효력발생일로부터 30일 전에 공지함과 동시에 “이용자”에 대하여 모바일메시지, 로그인 시 동의 창, 앱 내 DM 메시지 등의 전자적 수단을 통해 통지합니다.</li>
                                        <li>④ “회사”가 본 조 제3항에 따라 개정 이용 동의서를 공지 또는 통지하면서 “이용자”에게 30일 내에 동의 또는 거부의 의사표시를 하지 않으면 동의한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 “이용자”가 명시적으로 거부의사를 표명하지 아니한 경우 “이용자”가 개정 이용 동의서에 동의한 것으로 간주합니다. “이용자”가 개정 이용동의서의 내용을 거부하는 경우 “회사”는 해당 “이용자”에 대하여 개정 이용 동의서의 내용을 적용할 수 없으며, 이 경우 “이용자”는 이용계약을 해지할 수 있습니다. 다만, “회사”가 약관의 개정을 원인으로 이용자에게 기존 이용 동의서를 적용할 수 없는 특별한 사정이 있는 경우에, “회사”는 해당 “이용자”에 대하여 특별한 사정을 모바일메시지, 로그인 시 동의 창, 앱 내 DM 메시지 등의 전자적 수단을 통해 7일 전에 통지한 후 이용계약을 해지할 수 있습니다.</li>
                                        <li>⑤ 본 이용 동의서에 명시되지 않은 사항에 대해서는 관련 법령, 회사가 정한 클럽 타올라 앱 이용 안내문 등 및 일반적인 관례에 따릅니다.</li>
                                        <li>⑥ “이용자”는 본 이용 동의서에 대한 변경사항 등 공지 및 통지가 있을 경우, 이를 확인하여야 할 의무가 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제4조 (운영)</p>
                                    <p class="titHtext pdbNone">클럽 타올라 앱은 "회사" 및 제휴사가 운영하며, 본 약관에 동의하고 "회사"로부터 승인 받은 "이용자"에게 제공됩니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제5조 (“서비스”의 이용)</p>
                                    <ol>
                                        <li>① 클럽 타올라 앱은 25센트 라이드 앱 사용자 누구나 가입하여 사용할 수 있습니다. 단, “서비스”의 종류에 따라 그 이용 자격이 제한될 수 있습니다. 특정 “서비스”는 해당 프로그램에서 필요로 하는 인증 절차에 따라 인증을 완료해야만 이용이 가능합니다.</li>
                                        <li>
                                            ② 다음 각 호의 사유가 있는 경우, “회사”는 클럽타올라 앱 이용 신청을 거절하거나 사후에 이용 계약을 해지할 수 있습니다.
                                            <ol>
                                                <li>1. 본인 실명이 아닌 가명으로 신청하거나 타인의 명의를 이용하여 이용 신청한 경우</li>
                                                <li>2. “회사”의 윤리강령 및 행동지침에 위반하여 자격정지 등 조치 기간 중에 있는 경우</li>
                                                <li>3. 허위의 정보를 기재하거나, “회사”가 제시하는 내용을 기재하지 않은 경우 또는 기재한 내용에 오기 등이 있는 경우</li>
                                                <li>4. “이용자”가 되고자 신청하는 자의 귀책사유로 인하여 “회사”의 승낙이 불가능하거나 기타 “회사”가 정한 제반 사항을 위반하여 신청하는 경우</li>
                                                <li>5. 기타 본 약관에 위배되거나 위법 또는 부당한 이용 신청임이 확인된 경우</li>
                                            </ol>
                                        </li>
                                        <li>③ 제1항에 따른 이용계약을 체결하는 과정에서 “회사”는 제3자인 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.</li>
                                        <li>④ “회사”는 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 클럽 타올라 앱 이용 제공을 원칙으로 하지만, 정기점검이나 시스템의 업그레이드가 필요한 날 또는 시간에 일시 중단할 수 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제6조 (회사의 의무)</p>
                                    <ol>
                                        <li>① “회사”는 본 약관에서 정한 바에 따라 계속적, 안정적으로 클럽 타올라 앱을 운영할 의무가 있습니다. “회사”는 “이용자”의 개인 신상 정보를 “이용자” 본인의 승낙 없이 타인에게 누설, 배포해서는 안됩니다. 다만, 전기통신관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 해당 정보를 관계 국가기관에 제공할 수 있습니다.</li>
                                        <li>② 제1항의 범위 내에서, “회사”는 업무와 관련하여 개별 동의를 한 “이용자”에 대하여 전체 또는 일부의 개인정보에 관한 통계자료를 작성하여 이를 사용할 수 있고, 이를 위하여 “이용자”의 디바이스/모바일 웹에서 쿠키를 전송할 수 있습니다. 이 경우 “이용자”는 쿠키의 전송을 거부하거나 쿠키의 전송에 대하여 경고하도록 사용하는 디바이스의 설정을 변경할 수 있으며, 쿠키 설정 변경에 의해 클럽 타올라 앱 이용이 변경되는 것은 “이용자”의 책임입니다.</li>
                                        <li>③ “회사”는 “이용자”로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우에는 그 사유와 처리일정을 화면에 게시하거나 “이용자”에게 통보해야 합니다.</li>
                                        <li>④ “회사”는 『정보통신망 이용촉진 및 정보보호에 관한 법률』, 『통신비밀보호법』, 『전기통신사업법』 등 클럽 타올라 앱의 운영, 유지와 관련 있는 법규를 준수합니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제7조 (이용자의 의무)</p>
                                    <ol>
                                        <li>
                                            ① “이용자”는 클럽 타올라 앱을 이용할 때 다음 각 호의 행위를 하여서는 안됩니다.
                                            <ol>
                                                <li>1. 이용 신청 또는 변경 시 허위 사실을 기재하거나, 다른 “이용자”의 ID 및 비밀번호를 도용, 부정하게 사용하는 행위</li>
                                                <li>2. “회사”의 클럽 타올라 앱을 이용하여 얻은 정보를 “회사”의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위</li>
                                                <li>3. 타인의 명예를 손상시키거나 불이익을 주는 행위</li>
                                                <li>4. 게시판 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 행위</li>
                                                <li>5. “회사”의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위</li>
                                                <li>6. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위</li>
                                                <li>7. 클럽 타올라 앱과 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염 자료를 등록 또는 유포하는 행위</li>
                                                <li>8. 클럽 타올라 앱 운영을 고의로 방해하거나 클럽 타올라 앱의 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신거부의사에 반하여 광고성 정보를 전송하는 행위</li>
                                                <li>9. 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위</li>
                                                <li>10. 동의 받지 않은 다른 “이용자”의 개인정보를 수집, 저장, 공개하는 행위</li>
                                                <li>11. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위</li>
                                                <li>12. 재물을 걸고 도박하거나 사행행위를 하는 행위</li>
                                                <li>13. 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위</li>
                                                <li>14. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상생활을 방해하는 행위</li>
                                                <li>15. “서비스”에 게시된 정보를 “회사”의 승낙 없이 변경하는 행위</li>
                                                <li>16. 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보의 전송 또는 게시 행위</li>
                                                <li>17. “회사”의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 메일을 발송하는 행위</li>
                                                <li>18. 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 e-mail으로 발송하는 행위</li>
                                                <li>19. 스토킹(stalking) 등 다른 “이용자”을 괴롭히는 행위</li>
                                                <li>20. 기타 불법적이거나 부당한 행위</li>
                                            </ol>
                                        </li>
                                        <li>② “이용자”는 회원가입 신청 또는 회원정보 변경 시 허위 정보 또는 타인의 정보를 등록할 경우 회원가입을 전제로 한 일체의 권리를 주장할 수 없습니다.</li>
                                        <li>③ “이용자”는 본 약관에서 규정하는 사항과 기타 “회사”가 정한 제반 규정, 공지사항 등 “회사”가 공지하는 사항 및 관계 법령을 준수하여야 하며, 기타 “회사”의 업무에 방해가 되는 행위, “회사”의 명예를 손상시키는 행위를 해서는 안됩니다.</li>
                                        <li>④ “이용자”는 “회사”의 사전 승낙 없이 클럽 타올라 앱을 이용하여 영업활동을 할 수 없으며, 그 영업활동의 결과에 대해 회사는 책임을 지지 않습니다. 또한 “이용자”는 이와 같은 영업활동으로 “회사”가 손해를 입은 경우, “이용자”는 “회사”에 대해 손해배상의무를 지며, “회사”는 해당 “이용자”에 대해 클럽 타올라 앱 이용제한 및 적법한 절차를 거쳐 손해배상 등을 청구할 수 있습니다.</li>
                                        <li>⑤ “이용자”는 “회사”의 명시적 동의가 없는 한 클럽 타올라 앱의 이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며 이를 담보로 제공할 수 없습니다.</li>
                                        <li>⑥ “이용자”는 “회사” 및 제3자의 지적 재산권을 침해해서는 안됩니다.</li>
                                        <li>⑦ “이용자”는 회원계정 개설 시 정확하고 완전한 정보를 제공해야 합니다. 법률에 따라 “회사”가 책임지는 경우를 제외하고, “이용자”는 본인의 계정으로 행한 활동에 대해 단독을 책임을 부담하며, 각자 본인의 계정의 비밀번호의 보안을 유지하여야 합니다. </li>
                                        <li>⑧ “회사”는 법률이 허용하는 범위에서 “이용자” 계정의 무단이용으로 인하여 “이용자”가 입은 손실에 대하여 책임을 지지 않지만, “이용자”는 그러한 무단이용으로 인하여 “회사” 또는 제3자가 입은 손해에 대해 책임을 질 수 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제8조 (이용계약의 해제, 해지 등)</p>
                                    <ol>
                                        <li>① “이용자”는 언제든지 “회사”에서 정하는 방법에 따라 클럽 타올라 앱과 25센트 라이드 앱 이용 계약을 해지할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.</li>
                                        <li>② “이용자”가 클럽 타올라 앱과 25센트 라이드 앱 이용 계약을 해지할 경우, “회사”는 관련법 및 개인정보처리방침에 따라 “이용자”의 정보를 보유하는 경우를 제외하고는 해지 즉시 “이용자”의 클럽 타올라 앱 관련 모든 데이터를 삭제합니다.</li>
                                        <li>③ 이용계약 해지로 인해 발생한 불이익에 대한 책임은 법률상 “회사”의 책임이 있는 경우를 제외하고 “이용자” 본인이 부담하여야 하며, 이용계약이 종료되면 “회사”가 “이용자”에게 부가적으로 제공한 각종 혜택은 받을 수 없습니다.</li>
                                        <li>
                                            ④ “이용자”가 다음 각 호의 사유에 해당하는 경우, “회사”는 그 즉시 “이용자”와 이용계약을 해지할 수 있습니다. 다만, “회사”는 이용 계약 해지일 및 해지 사유를 이용자에게 제13조의 방법으로 통지해야 한다.
                                            <ol>
                                                <li>1. 25센트 라이드 앱 가입 신청 시 허위의 내용을 기재한 경우</li>
                                                <li>2. 클럽 타올라 앱에서 받은 보상을 부정한 방법 또는 목적으로 이용한 경우</li>
                                                <li>3. 클럽 타올라 앱 운영의 원활한 진행을 방해하는 행위를 하거나 이를 시도한 경우</li>
                                                <li>4. 고의로 “회사”의 영업을 방해한 경우</li>
                                                <li>5. 다른 “이용자”의 권리나 명예, 신용 기타 정당한 이익을 침해하거나 대한민국 법령 또는 선량한 풍속 기타 사회질서에 위배되는 행위를 한 경우</li>
                                                <li>6. 본 약관에 위배되는 행위를 한 경우</li>
                                                <li>7. 본 약관 제5조 제2항 및 제8조 제1항 각호의 사유 중 하나가 있음이 확인된 경우</li>
                                                <li>8. 기타 “회사”가 합리적인 판단에 기하여 클럽 타올라 앱의 제공을 거부할 필요가 있다고 인정할 경우</li>
                                            </ol>
                                        </li>
                                        <li>⑤ 본 조에 의한 이용계약 해제 또는 해지에 따른 “이용자” 자격은 이용계약 해지 요청일 또는 이용자격상실 통보 당일 즉시 상실됩니다.</li>
                                        <li>⑥ 이용계약이 종료됨으로써 발생한 손해는 관련 법령에서 별도로 규정하였거나 “회사”의 고의 또는 과실이 있는 경우를 제외하고 회사가 그 책임을 부담하지 않습니다. </li>
                                        <li>⑦ 본 조에 의한 이용계약의 해지 및 해제는 이미 발생한 양당사자의 권리관계 및 손해배상 청구권에 영향을 미치지 아니합니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제9조 (개인정보)</p>
                                    <p class="titHtext pdbNone">“회사”는 “이용자”가 안전하게 클럽 타올라 앱을 이용할 수 있도록 이용자의 개인정보보호를 위하여 개인정보보호정책을 실시하며, 이에 따라 “이용자”의 개인정보를 보호합니다. “회사”의 개인정보보호정책 및 개인정보 수집 및 활용, 이용기간 등에 관한 사항은 25센트 라이드 앱의 ‘개인정보 처리 방침’에서 확인할 수 있습니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제10조 (25센트 라이드 앱 운영 중단)</p>
                                    <ol>
                                        <li>① “회사”가 클럽 타올라 앱 운영을 중단할 경우 중단 시점 최소 3개월 이전에 “이용자”에게 공지하며, 동시에 “이용자”에 대해 제13조의 방법 등 전자적 수단을 이용하여 개별 통지합니다. 클럽 타올라 앱 운영의 종료기준일은 “이용자”에게 공지될 게시물 또는 전송될 전자적 수단에 의한 통지에 명시된 일자로 합니다.</li>
                                        <li>② 클럽 타올라 앱 운영 종료일까지 사용되지 않은 보상은 연계된 앱에 명시된 보상기준 종료기준일에 소멸됩니다.</li>
                                        <li>③ “회사”는 법령에 달리 규정된 경우를 제외하고 본 조에 따른 클럽 타올라 앱 운영의 중단에 대하여 어떠한 책임도 부담하지 않습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제11조 (손해 배상)</p>
                                    <ol>
                                        <li>① “이용자”가 본 약관의 규정을 위반함으로 인하여 “회사”에 손해가 발생하게 되는 경우, 본 약관을 위반한 “이용자”는 “회사”에 발생하는 모든 손해를 배상하여야 합니다.</li>
                                        <li>② “이용자”가 클럽 타올라 앱을 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 회사가 이용자 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 “이용자”는 본인의 책임과 비용으로 회사를 면책 시켜야 하며, “회사”가 면책되지 못한 경우 “이용자”는 그로 인하여 “회사”에 발생한 모든 손해를 배상하여야 합니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제12조 (면책사항)</p>
                                    <ol>
                                        <li>① “회사”가 천재지변 또는 이에 준하는 불가항력으로 인하여 클럽 타올라 앱 이용을 제공할 수 없는 경우 “회사”는 클럽 타올라 앱 이용 제공에 관한 책임을 면합니다.</li>
                                        <li>② “회사”는 “이용자”의 귀책사유로 인한 클럽 타올라 앱의 이용 장애에 대하여 책임을 지지 않습니다.</li>
                                        <li>③ “회사”는 “이용자”가 클럽 타올라 앱을 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며 그 밖에 클럽 타올라 앱을 통하여 얻은 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다.</li>
                                        <li>④ “회사”는 이용자 상호간 또는 이용자와 제휴사 등 제3자 상호간에 클럽 타올라 앱을 매개로 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 민, 형사상 책임을 부담하지 않습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제13조 (통지)</p>
                                    <ol>
                                        <li>① “회사”는 본 약관과 관련한 통지 시 이용자에게 모바일메시지, 로그인 시 동의 창, 앱 내 DM 메시지 등의 수단으로 개별 통지할 수 있습니다.</li>
                                        <li>② “회사”는 전체 또는 다수의 “이용자”에 대한 통지의 경우 클럽 타올라 앱 공지사항 페이지에 게시함으로써 개별 통지를 갈음할 수 있습니다. 다만, 클럽 타올라 앱 이용에 중대한 영향을 주는 사항에 대해서는 본 조 제1항의 통지 수단 중 하나 이상의 방법으로 통지합니다.</li>
                                        <li>③ 본 조에 따라 “회사”의 통지가 “이용자”의 수신 거부 또는 “이용자”가 제공한 휴대전화번호 등이 정확하지 않아 발생하는 오류 등에 대해서 “회사”는 책임지지 않습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제14조 (준거법 및 관할 법원)</p>
                                    <ol>
                                        <li>① 본 약관과 관련된 사항에 대하여는 대한민국의 법률을 적용합니다.</li>
                                        <li>② 클럽 타올라 앱 이용과 관련하여 “회사”와 “이용자” 사이에 분쟁이 발생한 경우, “회사”와 “이용자”는 분쟁의 해결을 위해 성실히 협의합니다.</li>
                                        <li>③ 본 약관 및 클럽 타올라 앱 이용과 관련하여 “회사”와 “이용자” 간 분쟁이 발생하여 소송이 제기되는 경우에는 민사소송법에 따라 관할법원을 정합니다. </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">부칙</p>
                                    <p class="titHtext pdbNone">이 약관은 2022년 10월 15일부터 적용됩니다.</p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : 앱 이용 동의서 -->

                    <!-- S : 개인 정보 이용 동의 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo02" ref="titNo02">개인 정보 수집∙이전 동의서(필수)</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext pdbNone">한국암웨이 주식회사 (이하 “한국암웨이”)는 클럽 타올라 앱 서비스를 제공하기 위하여 다음과 같이 귀하의 개인정보를 수집&middot;이용합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">○ 수집하는 개인정보 항목:</p>
                                    <p class="titH2">[필수항목]</p>
                                    <ol style="margin-bottom:8px;">
                                        <li>• 25센트 라이드 앱 DB에서 수집하는 정보:<br>닉네임, ABO 번호, 성별, 출생년도</li>
                                        <li>• 서비스 이용 시: 서비스 이용 기록, 이용정지 기록, 이용해지 기록, 접속로그, 쿠키 (Cookie), 국가정보, OS 버전 (모바일), 단말기 모델 (모바일), 운동기록정보(평균속도, 최고속도,  주행거리, 주행시간,  칼로리, 회전수)</li>
                                        <li>• (주)한국암웨이 DB에서 수집하는 정보:<br>(주)한국암웨이 회원 ID, 성명, 회원 유형(ABO/Member/Customer), 생년월일,핀, 이메일, 주소, 휴대폰번호</li>
                                    </ol>

                                    <p class="titH2">[선택항목]</p>
                                    <ol>
                                        <li>• 프로필 이미지</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">○ 개인정보의 수집 및 이용 목적:</p>
                                    <ol>
                                        <li>• 클럽 타올라 앱 이용에 따른 이용자 식별, 각종 서비스 관련 편의 제공 및 고지사항 전달</li>
                                        <li>• 고객상담, 불만 및 민원처리</li>
                                        <li>• 사업자 윤리강령 소정의 스폰서십 라인 규정 준수 확인</li>
                                        <li>• 서비스 및 제품 품질 향상을 위한 통계 작성 등 활용</li>
                                        <li>• 기타 ABO 사업관리 및 서비스 지원</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">○ 개인정보의 보유 및 이용기간:</p>
                                    <p class="titHtext pdbNone">한국암웨이는 이용자의 개인정보를 개인정보의 수집 및 이용목적이 달성되면 지체없이 파기합니다. 다만, 관련 법령의 규정, 부정 이용 방지, 탈퇴 회원 재가입 방지 목적 등 개인정보를 계속 보존할 필요가 있는 경우, 일정기간 동안 이용자의 개인정보를 아래 명시한 기간 동안 보관합니다. 이 경우, 한국암웨이는 보관하는 정보를 그 보관의 목적으로만 이용합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">&lt;전자상거래 등에서의 소비자 보호에 관한 법률&gt;</p>
                                    <ol>
                                        <li>• 표시, 광고에 관한 기록: <b>6개월</b></li>
                                        <li>• 계약 또는 청약철회 등에 관한 기록: <b>5년</b></li>
                                        <li>• 대금결제 및 재화 등의 공급에 관한 기록: <b>5년</b></li>
                                        <li>• 소비자 불만 또는 분쟁처리에 관한 기록: <b>3년</b></li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">&lt;통신비밀보호법&gt;</p>
                                    <ol>
                                        <li>• 이용자의 인터넷 등 로그기록: <b>3개월</b></li>
                                        <li>• 이용자의 접속지 추적자료, 그 외의 통신사실 확인 자료: <b>1년</b></li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">&lt;회사 내부 방침에 의한 정보보유 사유&gt;</p>
                                    <ol>
                                        <li>• 부정이용기록: <b>사업종료시까지</b></li>
                                        <li>• 탈퇴 회원 재가입 방지를 위한 최소 식별 정보보유: <b>6개월</b></li>
                                        <li>• ABO 윤리강령 소정의 스폰서십 라인 규정 준수 확인을 위한 기록: <b>2년</b></li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext pdbNone">※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 25센트 라이드 앱 이용이 불가합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext pdbNone">본인은 위 개인정보 수집 ∙ 이용에 동의합니다.</p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : 개인 정보 이용 동의 -->

                    <!-- S : 민감정보 활용 동의 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo03" ref="titNo03">민감정보 수집 ∙ 이전 활용 동의 (필수)</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext pdbNone">한국암웨이㈜는 클럽 타올라 앱 운영을 위하여 다음과 같이 25센트 라이드 앱에 입력된 귀하의 민감정보를 수집, 이용합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">○ 수집하는 민감정보의 항목:</p>
                                    <p class="titHtext pdbNone">- 키, 몸무게</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">○ 민감정보의 수집 및 이용 목적:</p>
                                    <p class="titHtext pdbNone">- 앱 내 보상 체계 반영을 위한 칼로리 소모량 측정</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">○ 민감정보의 보유 및 이용기간:</p>
                                    <p class="titHtext pdbNone">- 행사 종료 후 <b>36개월</b> 동안 보유</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext pdbNone">※ 귀하는 위 민감정보 수집·이용에 대한 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 클럽 타올라 앱 이용 및 관련 이벤트 참여가 불가합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext pdbNone">본인은 위 민감정보 수집 ∙ 이용에 동의합니다.</p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : 민감정보 활용 동의 -->

                    <!-- S : 개인정보 처리방침 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo04" ref="titNo04">한국암웨이 클럽타올라 앱 개인정보 처리방침</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext pdbNone">한국암웨이 주식회사(이하 “한국암웨이”)는 이용자의 개인정보를 소중하게 다루고 있으며, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보보호법」을 준수하기 위하여 노력하고 있습니다. 한국암웨이는 개인정보처리방침을 통하여 이용자로부터 제공받은 개인정보를 어떠한 용도와 방식으로 이용하고 있으며, 개인정보보호를 위해 어떠한 조치를 취하고 있는 지 알려드립니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">1. 개인정보의 수집 항목 및 이용 목적</p>
                                    <p class="titHtext pdbNone">한국암웨이는 원활한 고객상담, 각종 서비스의 제공을 위해 아래와 같은 개인정보를 수집하고 있습니다. 이용자의 개인정보는 밝힌 목적 이외에는 절대로 사용하지 아니하고 개인정보의 사용목적과 용도가 변경될 경우에 반드시 이용자로 등록된 모든 분에게 동의를 구할 것을 약속합니다. 개인정보의 수집 및 이용에 대한 동의 철회 시, 한국암웨이는 일정기간 보관 후 개인정보를 삭제합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">1.1 25센트 라이드 앱 DB에서 조회ㆍ활용하는 정보</p>
                                    <table class="tbl-type1 line-st">
                                        <caption>25센트 라이드 앱 DB에서 조회ㆍ활용하는 정보 표 : 구분, 개인정보항목, 이용목적</caption>
                                        <colgroup>
                                            <col width="15%">
                                            <col width="30%">
                                            <col width="55%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">구분</th>
                                                <th scope="col">개인정보항목</th>
                                                <th scope="col">이용목적</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>필수 정보</td>
                                                <td class="textL">(이용 동의 시) 닉네임, 비밀번호, ABO 번호, 성별, 출생년도</td>
                                                <td class="textL">
                                                    • 클럽 타올라 앱 이용에 따른 이용자 식별, 각종 서비스 관련 편의 제공 및 고지사항 전달<br>
                                                    • 고객상담, 불만 및 민원처리<br>
                                                    • 사업자 윤리강령 소정의 스폰서십 라인 규정 준수 확인
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>민감 정보</td>
                                                <td class="textL">(필수) 키, 몸무게</td>
                                                <td class="textL">
                                                    • 앱 내 보상 체계 반영을 위한 칼로리 소모량 측정
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">1.2 일반 개인정보</p>
                                    <table class="tbl-type1 line-st">
                                        <caption>일반 개인정보 표 : 구분, 개인정보항목, 이용목적</caption>
                                        <colgroup>
                                            <col width="15%">
                                            <col width="30%">
                                            <col width="55%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">구분</th>
                                                <th scope="col">개인정보항목</th>
                                                <th scope="col">이용목적</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>필수 정보</td>
                                                <td class="textL">
                                                    <b>(이용 동의 시)</b> 닉네임, 비밀번호, ABO 번호, 성별, 출생년도<br>
                                                    <b>(서비스 이용 시)</b> 서비스 이용 기록, 이용정지 기록, 이용해지 기록, 접속로그, 접속 IP, 국가정보, OS 버전 (모바일), 단말기 모델 (모바일), 운동기록정보(평균속도, 최고속도,  주행거리, 주행시간,  칼로리, 회전수)
                                                </td>
                                                <td class="textL">
                                                    • 클럽 타올라 앱 이용에 따른 이용자 식별, 각종 서비스 관련 편의 제공 및 고지사항 전달<br>
                                                    • 고객상담, 불만 및 민원처리<br>
                                                    • 사업자 윤리강령 소정의 스폰서십 라인 규정 준수 확인<br>
                                                    • 서비스 및 제품 품질 향상을 위한 통계 작성 등 활용<br>
                                                    • 기타 ABO 사업관리 및 서비스 지원
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>선택 정보</td>
                                                <td class="textL">
                                                    <b>프로필 이미지</b>
                                                </td>
                                                <td class="textL">
                                                    • 이용자 식별, 각종 편의 제공
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">1.3 (주)한국암웨이 회원 DB에서 조회ㆍ활용하는 정보</p>
                                    <table class="tbl-type1 line-st" style="margin-bottom:12px;">
                                        <caption>(주)한국암웨이 회원 DB에서 조회ㆍ활용하는 정보 표 : 구분, 개인정보항목, 이용목적</caption>
                                        <colgroup>
                                            <col width="15%">
                                            <col width="30%">
                                            <col width="55%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">구분</th>
                                                <th scope="col">개인정보항목</th>
                                                <th scope="col">이용목적</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>필수 정보</td>
                                                <td class="textL">[필수] (주)한국암웨이 회원 ID, 성명, 회원 유형(ABO/Member/Customer), 생년월일, 핀, 이메일, 주소, 휴대폰번호</td>
                                                <td class="textL">
                                                    • 이용자 식별 및 회원관리, 회원 정보 연동
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <p class="titHtext">
                                        * 필수 정보는 ABO 윤리강령 소정의 스폰서십 라인 규정 준수 확인 등의 목적으로 이용될 수 있습니다.<br>
                                        * 위 정보는 가입 당시 정보뿐만 아니라 정보 수정으로 변경된 정보를 포함합니다.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">한국암웨이는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
                                    <ol>
                                        <li>- 회원가입 및 서비스 이용 시 이용자가 개인정보 수집에 동의를 하고 클럽 타올라 앱을 통해 직접 정보를 입력하는 경우</li>
                                        <li>- 고객센터를 통한 상담 과정에서 메일, 팩스, 전화 등</li>
                                        <li>- 온·오프라인에서 진행되는 이벤트/행사 등 참여</li>
                                        <li>- 기기정보와 같은 생성정보는 클럽 타올라 앱 이용 과정에서 자동으로 생성되어 수집될 수 있음</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">2. 개인정보의 처리 및 보유기간</p>
                                    <p class="titHtext">한국암웨이는 이용자의 개인정보를 개인정보의 수집 및 이용목적이 달성되면 지체없이 파기합니다. 그리고 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정, 부정이용방지, 탈퇴 회원 재가입 방지 등 보존할 필요가 있는 경우, 일정기간동안 이용자의 개인정보를 아래 명시한 기간 동안 보관합니다. 이 경우, 한국암웨이는 보관하는 정보를 그 보관의 목적으로만 이용합니다.</p>

                                    <ol>
                                        <li>
                                            <p class="titH2">① 관련법령에 의한 정보보유 사유</p>
                                            <ol>
                                                <li>
                                                    &lt;전자상거래 등에서의 소비자 보호에 관한 법률&gt;
                                                    <ol>
                                                        <li>- 표시, 광고에 관한 기록: <b>6개월</b></li>
                                                        <li>- 계약 또는 청약철회 등에 관한 기록: <b>5년</b></li>
                                                        <li>- 대금결제 및 재화 등의 공급에 관한 기록: <b>5년</b></li>
                                                        <li>- 소비자 불만 또는 분쟁처리에 관한 기록: <b>3년</b></li>
                                                    </ol>
                                                </li>
                                                <li>
                                                    &lt;통신비밀보호법&gt;
                                                    <ol>
                                                        <li>- 이용자의 인터넷 등 로그기록: <b>3개월</b></li>
                                                        <li>- 이용자의 접속지 추적자료, 그 외의 통신사실 확인 자료: <b>1년</b></li>
                                                    </ol>
                                                </li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p class="titH2">② 회사 내부 방침에 의한 정보보유 사유</p>
                                            <ol>
                                                <li>- 부정이용기록: 사업종료 시까지</li>
                                                <li>- 탈퇴 회원 재가입 방지를 위한 최소 식별 정보보유: <b>6개월</b></li>
                                                <li>- ABO 윤리강령 소정의 스폰서십 라인 규정 준수 확인을 위한 기록: <b>2년</b></li>
                                            </ol>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">3. 개인정보의 제3 자 제공에 관한 사항</p>
                                    <p class="titHtext">한국암웨이는 이용자의 개인정보를 고지한 범위 내에서 사용하며, 범위를 초과하여 이용하거나 법령에 규정된 경우를 제외하고는 제3자에게 제공하지 않습니다. 다만, 필요한 경우에는 합당한 절차를 통해 이용자의 동의를 얻어 개인정보를 제공 또는 이용할 수 있습니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">4. 개인정보처리의 위탁에 관한 사항</p>
                                    <p class="titHtext">한국암웨이는 약속한 서비스 제공 및 향상을 목적으로 이용자의 개인정보의 수집, 취급, 관리 등을 아래 업체에 위탁하여 처리할 수 있으며 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 25센트 라이드 앱의 개인정보 위탁 처리 업체 및 위탁업무 내용은 다음과 같습니다.</p>
                                    <table class="tbl-type1 line-st">
                                        <caption>개인정보처리의 위탁에 관한 사항 표 : 수탁업체(수탁자), 위탁업무 내용</caption>
                                        <colgroup>
                                            <col width="50%">
                                            <col width="50%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">수탁업체(수탁자)</th>
                                                <th scope="col">위탁업무 내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>㈜지오아이티</td>
                                                <td>시스템 개발 및 운영, 유지보수</td>
                                            </tr>
                                            <tr>
                                                <td>㈜한국고용정보</td>
                                                <td>고객 문의 응대, 설문조사 등</td>
                                            </tr>
                                            <tr>
                                                <td>(주) 비즈마켓</td>
                                                <td>다타익선 마이크로 사이트 운영</td>
                                            </tr>
                                            <tr>
                                                <td>SendBird. Inc</td>
                                                <td>채팅 서비스 운영</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">5. 개인정보의 국외 이전</p>
                                    <p class="titHtext">한국암웨이 이용자 개인정보의 국외 이전에 대한 상세 내용은 아래와 같습니다.</p>
                                    <table class="tbl-type1 line-st">
                                        <caption>개인정보의 국외 이전 표 : 이전 받는 자, 이전 국가, 이전 항목, 이전 방법, 이전 유형, 이용 목적, 보유 및 이용기간 내용</caption>
                                        <colgroup>
                                            <col width="25%">
                                            <col width="*">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>이전 받는 자</th>
                                                <td class="textL">
                                                    Amazon Web Service<br>
                                                    - Stephen Schmit (CSO/CISO)<br>
                                                    - 1-206-266-1000
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>이전 국가</th>
                                                <td class="textL">미국</td>
                                            </tr>
                                            <tr>
                                                <th>이전 항목</th>
                                                <td class="textL">닉네임, 비밀번호, ABO 번호, 성별, 출생년도, 키, 몸무게</td>
                                            </tr>
                                            <tr>
                                                <th>이전 방법</th>
                                                <td class="textL">온라인 전송</td>
                                            </tr>
                                            <tr>
                                                <th>이전 유형</th>
                                                <td class="textL">처리위탁, 보관</td>
                                            </tr>
                                            <tr>
                                                <th>이용 목적</th>
                                                <td class="textL">시스템 운영/유지보수, 설문조사 및 글로벌 비즈니스 분석, 회원정보 관리</td>
                                            </tr>
                                            <tr>
                                                <th>보유 및 이용기간</th>
                                                <td class="textL">규정 준수 모니터링을 위해 2년 보유, 기타 관련법령에 의한 보유</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">6. 만 14세 미만 아동에 대한 정보보호에 관한 사항</p>
                                    <p class="titHtext">한국암웨이는 만 19세 이상만이 이용자 가입이 가능합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">7. 개인정보의 관리(열람, 정정, 삭제 등)와 파기 절차 및 방법</p>
                                    <p class="titHtext">
                                        이용자로부터 수집한 개인정보를 수집 · 이용 목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.<br>
                                        이용자는 언제든지 25센트 라이드 / 클럽 타올라 앱에 등록되어 있는 자신의 개인정보를 열람하거나 정정할 수 있으며 이용자 개인정보 삭제를 요청하실 수 있습니다.<br>
                                        단, 클럽 타올라 앱 자체적으로 생성된 정보 외 amway.co.kr과 연동되는 정보는 클럽 타올라 앱이 아닌 amway.co.kr을 통해 수정 및 삭제하실 수 있습니다.<br>
                                        또한, 탈퇴 회원의 동일 아이디 재가입 방지를 위한 최소한의 식별 정보는 탈퇴 후 6개월 간 삭제가 불가할 수 있습니다.<br>
                                        이용자는 개인정보의 수집, 이용에 대한 동의 철회(해지) 및 제3자 제공 동의의 철회를 전화, 팩스, 기타의 방법을 통하여 요청할 수 있으며 이 경우, 이용자 본인임을 확인한 후 처리가 이루어지게 됩니다. 수정된 정보는 처리가 완료된 시점부터 바로 적용이 되며 이용자 가입 해지를 원하실 경우 해지 신청 즉시 이용자와의 연락 후 한국암웨이 정책에 준하여 해지 절차를 밟게 됩니다.<br>
                                        이용자가 개인정보의 오류에 대한 정정을 요청한 경우 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.<br>
                                        한국암웨이는 이용자의 요청에 의해 해지 또는 삭제된 개인정보를 "개인정보 처리 및 보유기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 있도록 처리하고 있습니다.<br>
                                        또한 개인정보의 수집 목적 또는 제공받은 목적이 달성된 때에는 이용자의 개인정보를 지체 없이 파기합니다. 파기 절차와 방법은 다음과 같습니다.
                                    </p>
                                    <ol>
                                        <li>
                                            <p class="titH2">① 개인정보의 파기 절차</p>
                                            <p class="titHtext">이용자가 가입 등을 위해 입력하신 정보는 개인정보의 수집 및 이용 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보유 사유에 따라(개인정보 처리 및 보유기간 참조) 일정기간 저장된 후 파기됩니다. 이용자의 개인정보는 법률에 의한 경유가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</p>
                                        </li>
                                        <li>
                                            <p class="titH2">② 개인정보의 파기 방법</p>
                                            <p class="titHtext">한국암웨이는 귀중한 이용자의 개인정보를 안전하게 처리하며, 유출의 방지를 위하여 다음과 같은 방법을 통하여 개인정보를 파기합니다.</p>
                                            <ol>
                                                <li>- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통한 파기</li>
                                                <li>- 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법 사용</li>
                                            </ol>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">8. 개인정보의 기술적/관리적 보호 대책</p>
                                    <p class="titHtext">
                                        한국암웨이 클럽 타올라 앱 서비스는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 위조, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.<br>
                                        - 이용자의 개인정보는 비밀번호에 의해 철저히 보호되고 있습니다. 이용자 아이디(ID)의 비밀번호는 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다. 따라서 이용자 여러분께서는 비밀번호를 누구에게도 알려주시면 안됩니다. 본인의 개인정보는 책임 있게 관리되어야 하며 비밀번호나 개인정보 등의 유출에 대해서 회사는 어떠한 책임도 지지 않습니다.<br>
                                        - 한국암웨이는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.<br>
                                        - 개인정보의 훼손에 대비하여 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호 알고리즘 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.<br>
                                        - 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있고, 24시간 전문 보안 업체를 통하여 모니터링 및 응급대처방안을 준비하고 있으며, 기타 시스템적으로 안정성을 확보하기 위한 가능한 모든 기술적 보호장치를 갖추려 노력하고 있습니다.<br>
                                        - 한국암웨이의 개인정보관련 처리자는 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 개인정보 보호정책의 준수를 항상 강조하고 있습니다. 그리고 사내 정보보호 전담조직 등을 통하여 개인정보 보호정책의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로잡을 수 있도록 노력하고 있습니다.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">9. 개인정보보호책임자와 담당부서</p>
                                    <ol>
                                        <li>
                                            개인정보보호책임자: 이준범 전무
                                            <ol>
                                                <li>- 소속/직위: CSO / CPO / 전무</li>
                                                <li>- E-mail: securityteam@amway.com</li>
                                                <li>- 문의 전화 : 1588-0080</li>
                                            </ol>
                                        </li>
                                        <li>
                                            개인정보보호 담당부서
                                            <ol>
                                                <li>- E-mail: securityteam@amway.com</li>
                                                <li>- 문의 전화: 1588-0080</li>
                                            </ol>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">10. 개인정보관련 의견수렴 및 불만 처리</p>
                                    <p class="titHtext">한국암웨이는 개인정보보호와 관련하여 이용자 여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다. 이용자들은 “한국암웨이 개인정보보호책임자와 담당부서”를 참고하여 전화나 메일을 통하여 불만사항을 신고할 수 있고, 한국암웨이는 이용자들의 신고사항에 대하여 신속한 답변을 드릴 것입니다. 또한 한국암웨이의 “웹사이트” 이용 중 한국 암웨이의 개인정보보호에 관련된 처리에 대해 만족하지 못하실 경우에는 정부에서 운영중인 아래 기관을 통해 분쟁을 조정할 수 있습니다.</p>
                                    <table class="tbl-type1 line-st">
                                        <caption>개인정보관련 의견수렴 및 불만 처리 표 : 구분, 홈페이지, 전화 내용</caption>
                                        <colgroup>
                                            <col width="40%">
                                            <col width="40%">
                                            <col width="20%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">구분</th>
                                                <th scope="col">홈페이지</th>
                                                <th scope="col">전화</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>경찰청 사이버안전국</td>
                                                <td>
                                                    <a href="http://cyberbureau.police.go.kr" target="_blank">http://cyberbureau.police.go.kr</a>
                                                </td>
                                                <td>(국번없이) 182</td>
                                            </tr>
                                            <tr>
                                                <td>대검찰청 사이버수사과</td>
                                                <td>
                                                    <a href="http://www.spo.go.kr" target="_blank">http://www.spo.go.kr</a>
                                                </td>
                                                <td>(국번없이) 1301</td>
                                            </tr>
                                            <tr>
                                                <td>개인정보 침해신고센터<br>(한국인터넷 진흥원 운영)</td>
                                                <td>
                                                    <a href="http://privacy.kisa.or.kr" target="_blank">http://privacy.kisa.or.kr</a>
                                                </td>
                                                <td>(국번없이) 118</td>
                                            </tr>
                                            <tr>
                                                <td>개인정보 분쟁조정위원회<br>(개인정보보호위원회 운영)</td>
                                                <td>
                                                    <a href="http://kopico.go.kr" target="_blank">http://kopico.go.kr</a>
                                                </td>
                                                <td>02-1833-6972</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">11. 고지의 의무</p>
                                    <p class="titHtext">본 개인정보처리방침은 2024년 12월 19일부터 적용됩니다. 내용의 추가, 삭제 및 수정이 있을 시에는 시행일 이전에 공지사항 등을 통하여 고지할 것입니다. 또한 개인정보 처리방침에 버전번호 및 공고일자, 시행일자 등을 부여하여 개정여부를 쉽게 알 수 있도록 하고 있습니다.</p>
                                    <ol>
                                        <li>- 개인정보 처리방침 버전: v1.1</li>
                                        <li>- 공고일자: 2024년 12월 12일</li>
                                        <li>- 시행일자: 2024년 12월 19일</li>
                                    </ol>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : 개인정보 처리방침 -->
                </ul>
            </div>
        </div>
    </div>

    <transition name="fade">
      <div id="ScrollTopArea" class="scrollTopWrapper">
        <button type="button" class="toTop" @click="scrollToTop">TOP(위로이동)</button>
      </div>
    </transition>
    <div id="uiLayerMask" style="display:none"></div>
  </div>

  </body>
</template>

<script>

export default {
  name: 'termsCustomer',
  data () {
    return {}
  },
  methods: {
    scrollToTop () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    scrollToElement (target) {
      let element = this.$refs[target]
      let top = element.offsetTop
      window.scroll({
        left: 0,
        top: top,
        behavior: 'smooth'
      })
    },
    eventHandlerWrapper (callback) {
      let tick = false

      return () => {
        if (tick) {
          return
        }

        tick = true

        return requestAnimationFrame(() => {
          tick = false
          return callback()
        })
      }
    },
    toggleButton () {
      this.toggle = window.scrollY !== 0
    }
  },
  mounted: function () {
    this.toggle = window.scrollY !== 0

    window.addEventListener('scroll', this.eventHandlerWrapper(this.toggleButton), { passive: true })
    let termsIndex = this.$route.query['terms-index']
    if (termsIndex) {
      setTimeout(() => {
        let element = this.$refs['titNo0' + termsIndex]
        if (element) {
          window.scroll({
            top: element.offsetTop,
            left: 0,
            behavior: 'smooth'
          })
        }
      }, 400)
    }
  },
  created: function () {
  }
}
</script>

<style>
@import './css/akl-compliance-renewal.css';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/amwayterms/termsClubtaola.vue